export function constructSnippet({
  status,
  title,
}: {
  status?: 'pristine' | 'dirty';
  title?: string;
}) {
  let codeSnippet = `const event = {
  title: 'Change me!',
  startsAt: '2023-05-29T16:00:00Z',
  duration: 4,
  confirmed: true,
};`;

  if (status === 'dirty') {
    codeSnippet = `${codeSnippet}

event.title = "${title}"`;
  }

  return codeSnippet;
}
